<template>
  <div class="h-screen flex flex-col items-center relative overflow-hidden">
    <LogoSvg />
    <div
      class="flex justify-center items-center w-3/12 absolute top-3 left-1/2 -translate-x-1/2"
    >
      <img src="@/assets/logo-1.webp" alt="logo" />
    </div>
    <!-- Main Content -->
    <div
      class="px-4 p-1 flex flex-col justify-center bg-transparent shadow-md drop-shadow-2xl lg:p-2 rounded-md mb-36"
    >
      <div class="text-center">
        <div class="mt-0"  v-if="successStatus">
          <!-- Lottie Voice Animation -->
          <Vue3Lottie
            :animationData="jsonFile"
            :height="300"
            :width="300"
            class="rounded-full"
          />
        </div>
        <div class="text-white" v-else>
          جاري التحقق من حالة الدفع...
        </div>
        <p class="text-white text-lg font-bold" v-show="successStatus">تم  الإشتراك بنجاح!</p>
        <p class="text-gray-500 text-lg font-bold" v-show="successStatus">
          يمكنك الآن متابعة المشاهدة
        </p>
      </div>
    </div>
    
    <!-- Mobile Bottom Sheet -->
    <ContinueApp 
      v-if="showBottomSheet && isMobile"
      ref="continueApp"
      :auto-show="false"
    />
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import animationData from "@/assets/success.json";
import LogoSvg from "@/components/svg/LogoSvg.vue";
import ContinueApp from "@/components/payments/ContinueApp.vue";
import { mapActions } from "pinia";
import { useFawryStore } from "@/stores/fawry";
import { useToast } from "vue-toastification";

export default {
  components: {
    Vue3Lottie,
    LogoSvg,
    ContinueApp,
  },
  data() {
    return {
      lottieOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
      jsonFile: animationData,
      successStatus: false,
      toast: useToast(),
      isMobile: false,
      showBottomSheet: false,
    };
  },
  methods: {
    ...mapActions(useFawryStore, ["verifyFawryPaymentStatus"]),
    
    detectMobile() {
      // Check for mobile devices
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      const isSmallScreen = window.innerWidth <= 768;
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      this.isMobile = isMobileDevice || (isSmallScreen && hasTouchScreen);
      console.log("Fawry Mobile detection:", { 
        userAgent: userAgent.substring(0, 50) + "...", 
        isMobileDevice, 
        isSmallScreen, 
        hasTouchScreen, 
        isMobile: this.isMobile,
        screenWidth: window.innerWidth
      });
    },
    
    handleSuccessFlow() {
     const origin = localStorage.getItem("origin") || "web";
      if (this.isMobile && origin === "app") {
        // Show bottom sheet for mobile users
        console.log("Fawry Mobile user detected, showing bottom sheet");
        this.showBottomSheet = true;
        
        // Trigger the bottom sheet to open
        this.$nextTick(() => {
          if (this.$refs.continueApp) {
            this.$refs.continueApp.openBottomSheet();
          }
        });
      } else {
        // Desktop users go directly to home
        console.log("Fawry Desktop user detected, redirecting to home");
        this.redirectToHome();
      }
    },
    
    redirectToHome() {
      setTimeout(() => {
        this.$router.push({ name: "home" });
      }, 500);
    },
  },
  
  mounted() {
    // Listen for window resize to handle orientation changes
    window.addEventListener('resize', this.detectMobile);
  },
  
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('resize', this.detectMobile);
  },
 async created() {
    // Detect mobile device
    this.detectMobile();
    
    try{
        await this.verifyFawryPaymentStatus(this.$route.params.merchantRefNumber).then((response)=>{
            if(response.data.success){
                this.successStatus = true;
                this.toast.success("تم التحقق من حالة الدفع عبر فوري بنجاح");
                
                // Wait for success animation to show, then handle mobile/desktop flow
                setTimeout(() => {
                  this.handleSuccessFlow();
                }, 2000);
            }else{
                this.successStatus = false;
                this.toast.error("فشل في التحقق من حالة الدفع عبر فوري");
                // On failure, redirect to home after showing error
                setTimeout(() => {
                  this.$router.push({ name: "home" });
                }, 3000);
            }
        });
    }catch(error){
        console.error("Error verifying Fawry payment status:", error);
        this.toast.error("حدث خطأ في التحقق من حالة الدفع");
        // On error, redirect to home
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 3000);
    }
  },
};
</script>

<style scoped>
/* Your existing styles */
</style>

<style scoped></style>
